import React from 'react';
import {useAuth0} from '@auth0/auth0-react';

import {Link, MenuItem, useBreakpointValue} from '@spothero/ui';

import Config from 'hooks/config';
import {ROUTES} from 'constants/app-routes';
import {configureLogoutCookies} from 'utils/auth';

const SignOutButton = () => {
    const {siteUrl} = Config;
    const {logout, isAuthenticated} = useAuth0();
    const logoutUrl = `${siteUrl}/logout`;
    const isMobile = useBreakpointValue({
        base: true,
        tablet: false,
    });

    const handleClick = () => {
        configureLogoutCookies();

        logout({
            returnTo: isAuthenticated
                ? `${window.location.origin}${Config.basename}${ROUTES.login}`
                : logoutUrl,
        });
    };

    return !isMobile ? (
        <MenuItem
            as="button"
            variant="tertiary"
            fontSize="base"
            color="error"
            paddingX={4}
            paddingY={2.5}
            _hover={{color: 'red.800'}}
            onClick={handleClick}
            data-testid="ButtonSignOut"
        >
            Sign Out
        </MenuItem>
    ) : (
        <Link
            onClick={handleClick}
            fontSize="base"
            color="error"
            paddingX={4}
            paddingY={2.5}
            _hover={{color: 'red.800'}}
        >
            Sign Out
        </Link>
    );
};

export default SignOutButton;
